import { getPackageName } from "../utils";
const namespace = `io.github.t83714/${getPackageName()}/ReducerRegistry`;
export default namespace;
